// import _ from 'lodash';
import { loadPrograms } from '@/program/api';
import { loadEpisodes } from '@/episode/api';
import { loadVideos } from '@/video/api';
import { loadCollections } from './api';

const getLoadByCollectionType = (filter, collectionType) => {
  let filterData = filter;
  if (collectionType === 'playlist') {
    filterData = filterData ? { ...filterData, type: 'playlist' } : { type: 'video' };
  }
  switch (collectionType.toLowerCase()) {
    case 'video':
      return loadVideos(filterData);
    case 'episode':
      return loadEpisodes(filterData);
    case 'program':
      return loadPrograms(filterData);
    case 'playlist':
      return loadCollections(filterData);
    default:
      return loadCollections(filterData);
  }
};

const getCollectionTitleModal = (collectionType) => {
  switch (collectionType.toLowerCase()) {
    case 'video':
      return 'เพิ่มวิดีโอลงเพลย์ลิสต์';
    case 'episode':
      return 'เพิ่มตอนลงคอลเล็คชั่น';
    case 'program':
      return 'เพิ่มรายการลงคอลเล็คชั่น';
    default:
      return 'เพิ่มวิดีโอลงเพลย์ลิสต์';
  }
};

const generateModalTitleByCollectionType = (collectionType) => {
  switch (collectionType.toLowerCase()) {
    case 'video':
      return 'เพิ่มวิดีโอเข้าเพลย์ลิสต์';
    case 'episode':
      return 'เพิ่มเข้าชุดตอน';
    case 'program':
      return 'เพิ่มเข้าชุดรายการ';
    default:
      return 'เพิ่มของเข้าคอลเล็คชั่นไอเทม';
  }
};

const getCollectionTypeName = (collectionType) => {
  if (collectionType) {
    switch (collectionType.toLowerCase()) {
      case 'video':
        return 'เพลย์ลิสต์';
      case 'episode':
        return 'ตอน';
      case 'program':
        return 'รายการ';
      default:
        return 'คอลเล็คชั่นไอเทม';
    }
  }
  return 'คอลเล็คชั่นไอเทม';
};

const getSelectorCollectionTypePlaceHolder = (collectionType) => {
  switch (collectionType.toLowerCase()) {
    case 'video':
      return 'เลือกวิดีโอ';
    case 'episode':
      return 'เลือกตอน';
    case 'program':
      return 'เลือกรายการ';
    case 'playlist':
      return 'เลือกเพลย์ลิสต์';
    default:
      return 'เลือกคอลเล็คชั่นไอเทม';
  }
};

export {
  getLoadByCollectionType,
  getCollectionTitleModal,
  generateModalTitleByCollectionType,
  getCollectionTypeName,
  getSelectorCollectionTypePlaceHolder,
};
